type Empty = null | undefined

export const errorMessages = {
  ERROR_FIELD_REQUIRED: () => 'This field is required',
  ERROR_GREATER_THAN_OR_EQUAL_TO_SPECIFIED_FIELD: (value: string | Empty) =>
    `Value should be greater than or equal to ${value}`,
  ERROR_GREATER_THAN_OR_EQUAL_TO_SPECIFIED_VALUE: (value: string | Empty) =>
    `Value should be greater than or equal to ${value}`,
  ERROR_GREATER_THAN_SPECIFIED_FIELD: (value: string | Empty) =>
    `Value should be greater than ${value}`,
  ERROR_GREATER_THAN_SPECIFIED_VALUE: (value: string | Empty) =>
    `Value should be greater than ${value}`,
  ERROR_INVALID_DURATION: () => 'Invalid duration format. Please use hh:mm',
  ERROR_INVALID_NUMERIC: () => 'This field only accepts numeric values',
  ERROR_LESS_THAN_OR_EQUAL_TO_SPECIFIED_FIELD: (value: string | Empty) =>
    `Value should be less than or equal to ${value}`,
  ERROR_LESS_THAN_OR_EQUAL_TO_SPECIFIED_VALUE: (value: string | Empty) =>
    `Value should be less than or equal to ${value}`,
  ERROR_LESS_THAN_SPECIFIED_FIELD: (value: string | Empty) => `Value should be less than ${value}`,
  ERROR_LESS_THAN_SPECIFIED_VALUE: (value: string | Empty) => `Value should be less than ${value}`,
  ERROR_MAX_TEXT_LENGTH: (value: string | Empty) => `Maximum text length is ${value} characters`,
  ERROR_MIN_TEXT_LENGTH: (value: string | Empty) => `Minimum text length is ${value} characters`,
  ERROR_EQUAL_TO_SPECIFIED_VALUE: (value: string | Empty) => `Value should be equal to ${value}`,
  ERROR_EQUAL_TO_SPECIFIED_FIELD: (value: string | Empty) =>
    `Value should be or equal to '${value}'`,
  ERROR_AFTER_SPECIFIED_FIELD_IN: (value: string | Empty) =>
    `Value should be equal to or after: '${value}'`,
  ERROR_BEFORE_SPECIFIED_FIELD_IN: (value: string | Empty) =>
    `Value should be equal to or before: '${value}'`,
  ERROR_AFTER_SPECIFIED_FIELD_EX: (value: string | Empty) => `Value should be after: '${value}'`,
  ERROR_BEFORE_SPECIFIED_FIELD_EX: (value: string | Empty) => `Value should be before: '${value}'`,
  ERROR_AFTER_SPECIFIED_DATE_EX: (value: string | Empty) => `Value should be after '${value}'`,
  ERROR_BEFORE_SPECIFIED_DATE_EX: (value: string | Empty) => `Value should be before '${value}'`,
  ERROR_AFTER_SPECIFIED_DATE_IN: (value: string | Empty) =>
    `Value should be equal to or after '${value}'`,
  ERROR_BEFORE_SPECIFIED_DATE_IN: (value: string | Empty) =>
    `Value should be equal to or before '${value}'`,
}
